<sew-dialog ws [closeButton]="false" [attr.open]="displayCancelDialog ? true : null" size="xs">
    <p>
        {{ labels?.CMS_MARKET_REGULATION_CANCEL_DIALOG_TEXT }}
    </p>
    <sew-ws-button slot="button">
        <button
            [innerText]="labels?.CMS_MARKET_REGULATION_CANCEL_DIALOG_CANCEL"
            (click)="cancelFilterChange()"
        ></button>
    </sew-ws-button>
    <sew-ws-button slot="button" hierarchy="primary">
        <button
            [innerText]="labels?.CMS_MARKET_REGULATION_CANCEL_DIALOG_CONTINUE"
            (click)="confirmFilterChange()"
        ></button>
    </sew-ws-button>
</sew-dialog>

<sew-ws-content-wrapper>
    @if (isPreview) {
        <reg-preview-dashboard class="filter"> </reg-preview-dashboard>
    }

    @if (currentPage === 'landingPage') {
        <sew-headline level="1">{{ labels?.CMS_MARKET_REGULATION_INTRO_HEADLINE }}</sew-headline>
        <sew-ws-paragraph size="2">
            {{ labels?.CMS_MARKET_REGULATION_INTRO_TEXT }}
        </sew-ws-paragraph>
    } @else {
        <sew-headline level="1">{{ labels?.CMS_MARKET_REGULATION_FILTER_HEADLINE }}</sew-headline>
    }
    <div [ngClass]="currentPage === 'landingPage' ? 'container container-reverse' : ''">
        <div class="container filter">
            <sew-combobox
                #countryDropdown
                ws
                (mouseup)="scrollToFilterTop($event)"
                (touchend)="scrollToFilterTop($event)"
                (itemSelected)="countrySelected($event)"
                [placeholder]="labels?.CMS_MARKET_REGULATION_FILTER_COUNTRY"
                [comboboxId]="'country'"
                [hideNoSelectionOption]="true"
            >
                <select
                    title="{{ labels?.CMS_MARKET_REGULATION_FILTER_COUNTRY }}"
                    [ngModel]="selectedCountryId"
                >
                    <option></option>
                    @for (country of $any(countries | dropdownInput | async) ?? []; track country) {
                        <option [value]="country.value">
                            {{ country.name }}
                        </option>
                    }
                </select>
            </sew-combobox>

            <sew-combobox
                ws
                (mouseup)="scrollToFilterTop($event)"
                (touchend)="scrollToFilterTop($event)"
                (itemSelected)="componentSelected($event)"
                [disabled]="!selectedCountryId ? true : false"
                [placeholder]="labels?.CMS_MARKET_REGULATION_FILTER_COMPONENT"
                [comboboxId]="'component'"
                [hideNoSelectionOption]="true"
            >
                <select #componentDropdown title="{{ labels?.CMS_MARKET_REGULATION_FILTER_COMPONENT }}">
                    <option></option>
                    @for (component of $any(components | dropdownInput | async) ?? []; track component) {
                        <option
                            [value]="component.value"
                            [selected]="component.value === selectedComponentId + '' ? true : false"
                        >
                            {{ component.name }}
                        </option>
                    }
                </select>
            </sew-combobox>

            <sew-combobox
                ws
                (mouseup)="scrollToFilterTop($event)"
                (touchend)="scrollToFilterTop($event)"
                (itemSelected)="regulationSelected($event)"
                [disabled]="!selectedComponentId || !selectedCountryId ? true : false"
                [placeholder]="labels?.CMS_MARKET_REGULATION_FILTER_REGULATION"
                [comboboxId]="'regulation'"
                [hideNoSelectionOption]="true"
            >
                <select #regulationsDropdown title="{{ labels?.CMS_MARKET_REGULATION_FILTER_REGULATION }}">
                    <option></option>
                    @for (regulation of $any(regulations | dropdownInput | async) ?? []; track regulation) {
                        <option
                            [value]="regulation.value"
                            [selected]="regulation.value === selectedRegulationId + '' ? true : false"
                        >
                            {{ regulation.name }}
                        </option>
                    }
                </select>
            </sew-combobox>

            <sew-ws-button>
                <button
                    class="slotted-result-button"
                    [disabled]="!selectedRegulationId || !selectedComponentId || !selectedCountryId"
                    (click)="handleButtonClick()"
                >
                    {{
                        currentPage === 'landingPage'
                            ? labels?.CMS_MARKET_REGULATION_SHOW_RESULTS
                            : labels?.CMS_MARKET_REGULATION_BACK_TO_MAP
                    }}
                </button>
            </sew-ws-button>
        </div>
        <div #routerOutletWrapper>
            <router-outlet></router-outlet>
        </div>
    </div>
</sew-ws-content-wrapper>

<reg-energy [labels]="labels"></reg-energy>
